import React, { useMemo } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import LogoWithText from '../../../assets/logoWithText.png';
import AltLogo from '../../../assets/HeaderIcons/PeopleLens_Logo.svg';

import { COLORS } from '../../../plTheme';

import { useGlobalStyles } from '../../../plStyles';
import { _t_ } from '../../../utils/translation/translation';
import { dates, quartersWithData } from '../../../config';
import { format, utcToZonedTime } from 'date-fns-tz';

const useStyles = makeStyles(() => ({
  footer: {
    padding: '3mm 0mm',
    alignItems: 'center',
  },
  footerImage: {
    height: 33,
    width: 116,
  },
  altFooterImage: {
    height: 45,
    width: 116,
  },
  mainTitle: {
    color: COLORS.TEXT_LOW_EMPHASIS,
    textAlign: 'center',
  },
}));

export interface FooterProps {
  useAltLogo?: boolean;
  activeQuarter: number;
  period: string;
}

const Footer: React.FC<FooterProps> = ({
  useAltLogo,
  activeQuarter,
  period,
}: FooterProps) => {
  const datesTemp = [...dates];
  const classes = useStyles();
  const globalClasses = useGlobalStyles();
  const year = new Date().getFullYear();
  const QUARTER_NAMES = useMemo(() => [...Object.keys(quartersWithData)], [
    quartersWithData,
  ]);
  // const prevMonth = new Date(new Date().setMonth(new Date().getMonth() - 1));
  // const prevMonth2 = new Date(new Date().setMonth(new Date().getMonth() - 2));

  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-between"
        spacing={1}
        className={`${classes.footer}`}
      >
        <Grid item>
          <Typography
            className={`${globalClasses.body1WidgetTitle} ${classes.mainTitle}`}
          >
           {format(
              utcToZonedTime(new Date(datesTemp[activeQuarter].startDate), 'UTC'),
              'MMM yy',
            )}{' - '}
            {format(
              utcToZonedTime(new Date(datesTemp[activeQuarter].endDate), 'UTC'),
              'MMM yy',
            )}{' '}
            {`(${QUARTER_NAMES[activeQuarter]})`}
            {/* {activeQuarter == 0 ? (
              <></>
            ) : activeQuarter == 5 ? (
              <>(H1)</>
            ) : activeQuarter == 6 ? (
              <>(H2)</>
            ) : (
              <>
                (Q
                {activeQuarter})
              </>
            )} */}
          </Typography>
        </Grid>
        <Grid item>
          <img
            src={useAltLogo ? AltLogo : LogoWithText}
            alt="People Lens"
            className={
              useAltLogo
                ? `${classes.altFooterImage}`
                : `${classes.footerImage}`
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Typography
            className={`${globalClasses.roboto400px9px16px} ${classes.mainTitle}`}
          >
            {_t_(`@${year} PeopleLens inc. Confidential and proprietary.`)}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default Footer;
